import { configureStore } from '@reduxjs/toolkit';
import { app } from './app/reducers.ts';
import { toasts } from './toasts/reducers.ts';

export const store = configureStore({
  reducer: { app, toasts }
});